import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import { Translator } from 'js/shims-vue';

interface Option {
    value: string;
    label: string;
}

interface Props {
    activeFilter: string[];
    overviewType: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineAnnotationFilters',
  props: {
    activeFilter: {},
    overviewType: {}
  },
  emits: ['filterUpdate'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const $t = inject('$t') as Translator;

const store = useStore();

const options = computed<Option[]>(() => {
    const list: Option[] = [{ value: 'all', label: $t.__('common.labels.all') }];

    if (props.overviewType === 'third') {
        list.push({
            value: 'third',
            label: store.getters.identity.isCorporation
                ? $t.__('common.labels.company')
                : $t.__('common.labels.individual'),
        });
    }

    list.push(
        { value: 'opportunity', label: $t.__('common.labels.opportunity') },
        { value: 'people', label: $t.__('common.labels.contact') },
        { value: 'estimate', label: $t.__('common.labels.estimate') },
        { value: 'invoice', label: $t.__('common.labels.invoice') },
    );

    return list;
});

const handleChange = (value: string): void => {
    if (value !== '') {
        emit('filterUpdate', [value]);
    }
};

return (_ctx: any,_cache: any) => {
  const _component_CompassSegmentedControl = _resolveComponent("CompassSegmentedControl")!

  return (_openBlock(), _createBlock(_component_CompassSegmentedControl, {
    modelValue: __props.activeFilter[0],
    options: options.value,
    "onUpdate:modelValue": handleChange
  }, null, 8 /* PROPS */, ["modelValue", "options"]))
}
}

})